export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-interpolate/src/constant.js
// module id = q3H2
// module chunks = 0